import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-12 px-4 flex items-center justify-center">
      <div className="prose dark:prose-invert max-w-4xl w-full p-8 sm:p-12 bg-white/80 dark:bg-dark-surface/80 backdrop-blur-md rounded-[3rem] border border-light-gray/20 dark:border-dark-border/20 shadow-float-lg">
        <h1 className="text-4xl font-black text-charcoal dark:text-white mb-8 tracking-tight">Terms of Service</h1>
        <p className="text-muted-gray font-bold uppercase tracking-widest text-xs mb-8">Last updated: February 15, 2026</p>

        <section className="space-y-6 text-charcoal dark:text-gray-300">
          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">1. Introduction</h2>
            <p>Welcome to Safzi ("Platform"), a direct agent-to-client system designed to streamline funding between agents and clients on Deriv. By using our Platform, you agree to these Terms of Service ("Terms").</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">2. Scope of Service</h2>
            <p>The Platform facilitates funding transactions between verified agents and clients. We provide an interface to execute, track, and record these transactions. The Platform itself does not hold, process, or route any funds. All financial transactions occur directly between users and Deriv.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">3. User Accounts & Obligations</h2>
            <p>Both Agents and Clients must create an account and link their Deriv trading account via a secure OAuth process. You are required to provide a valid email address and phone number for verification. You are responsible for all activities that occur under your account and for maintaining the security of your login credentials.</p>
            <p className="mt-2 font-bold text-soft-green">Agents are solely responsible for verifying that they have received the correct payment from a Client before releasing any funds through the Deriv API.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">4. Fees</h2>
            <p>The Platform is currently in a zero-fee beta period. We reserve the right to introduce fees in the future. Any changes to the fee structure will be communicated to you in advance.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">5. Disputes</h2>
            <p>The Platform provides a basic mechanism for flagging disputed transactions. In the event of a dispute, an administrator may review the transaction logs and take manual action. However, the Platform is not responsible for mediating or resolving disputes between users. We do not offer any guarantees or insurance against financial losses.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">6. Disclaimers</h2>
            <p>The Platform is provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the reliability, security, or availability of the service. We are not liable for any damages or losses resulting from your use of the Platform.</p>
          </div>
        </section>
        
        <div className="mt-12 pt-8 border-t border-light-gray/20">
          <button onClick={() => navigate(-1)} className="text-soft-green font-black hover:text-light-mint transition-colors bg-transparent border-none cursor-pointer flex items-center gap-2">
            &larr; Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
